<template>
  <div>
    <!-- 설명 -->
    <p class="mb-5" style="color: #4839eb">※ 8대 위험요인(사다리/비계, 지붕, 고소작업대, 방호장치, 혼재작업, 충돌방지 장치, LOTO)에 대한 위험성은 필히 반영</p>

    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date']"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '회사명',
      }"
    />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>평가종류</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가자</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" />
        </div>
        <div>
          <div>평가일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.inputA_3 }}</p>
          <date-selector v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 위험성평가표 -->
    <table-risk-appraisal592 class="mt-5" title="위험성평가표" v-model="form.riskAppraisalList" :isPrint="isPrint" :readonly="board.readonly" :hide-code-number="true" />

    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 확인자</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>담당</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>검토</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>승인</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TableRiskAppraisal592 from "@/views/boards/single-page/592/TableRiskAppraisal592.vue";

export default {
  components: {
    TableRiskAppraisal592,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.riskAppraisalList": {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.disasterList = value.map((item) => item.input_5);
        this.form.disasterString = this.form.disasterList.toString();

        this.form.sum_L = 0;
        this.form.sum_ML = 0;
        this.form.sum_M = 0;
        this.form.sum_H = 0;
        this.form.sum_HH = 0;

        value.forEach((item) => {
          switch (item.input_9) {
            case "1~2(L)":
              this.form.sum_L += 1;
              break;
            case "3~4(ML)":
              this.form.sum_ML += 1;
              break;
            case "6(M)":
              this.form.sum_M += 1;
              break;
            case "8~9(H)":
              this.form.sum_H += 1;
              break;
            case "12~16(HH)":
              this.form.sum_HH += 1;
              break;
          }
        });
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        riskAppraisalList: [
          {
            id: 1,
            input_check: false,
            input_1: "고소작업대 작업",
            input_2: "고소작업대(리프트) 사용 작업",
            input_3: "전기적 요인",
            input_4: "전신주 및 전로 근접 작업중 감전 ",
            input_5: "감전",
            input_6: "전로에 근접하여 작업을 하는 때에는 작업감시자를 배치, 정전 및 방호조치 후 작업",
            input_7: "2",
            input_8: "3",
            input_9: "6(M)",
            input_9_color: "#c95611",
            input_10: "",
          },
          {
            id: 2,
            input_check: false,
            input_1: "고소작업대 작업",
            input_2: "고소작업대(리프트) 사용 작업",
            input_3: "전기적 요인",
            input_4: "작업대를 상승하던중 구조물 등에 협착",
            input_5: "협착",
            input_6: "과상승방지장치 설치 및 상승작업 시 상부 확인 철저",
            input_7: "2",
            input_8: "3",
            input_9: "8~9(H)",
            input_9_color: "#E42728",
            input_10: "",
          },
          {
            id: 3,
            input_check: false,
            input_1: "고소작업대 작업",
            input_2: "고소작업대(리프트) 사용 작업",
            input_3: "전기적 요인",
            input_4: "상부 작업중 낙하물 발생으로 하부 근로자 맞음",
            input_5: "맞음",
            input_6: "작업장 하부에 관계자외 출입 신호 통제",
            input_7: "2",
            input_8: "2",
            input_9: "3~4(ML)",
            input_9_color: "#3c3c3c",
            input_10: "",
          },
        ],

        fileList: [],

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },

        disasterList: [],
        disasterString: "",
        sum_L: 0,
        sum_ML: 0,
        sum_M: 0,
        sum_H: 0,
        sum_HH: 0,
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
